export default __webpack_public_path__ + "static/media/Laser Eyes.b001fb71.gif";